import React, { useContext, useEffect } from 'react';
import { useIntl } from 'react-intl-next';
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766
import styled from '@emotion/styled';
import Button from '@atlaskit/button/custom-theme-button';
import { ConfluenceLogo } from '@atlaskit/logo';
import ShortcutIcon from '@atlaskit/icon/glyph/shortcut';
import { ExperienceContext, ExperienceTrackerContext } from '@atlassian/experience-tracker';
import { ExperienceReasons } from '../experience-tracker/ExperienceNames';
import { LoginToConfluenceIcon } from '../assets/LoginPageIconSVG';
import messages from './messages';
const LOGIN_ISSUES_RELATED_TO_BROWSER_COOKIES = 'https://support.atlassian.com/atlassian-account/docs/login-issues-related-to-browser-cookies/';

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const Container = styled.div({
  alignItems: 'center',
  display: 'flex',
  flexDirection: 'column',
  fontSize: 'medium',
  height: '500px',
  justifyContent: 'space-around',
  margin: 'auto',
  position: 'relative',
  textAlign: 'center'
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const StyledLoginPageIconSVG = styled(LoginToConfluenceIcon)({
  '&&': {
    marginTop: "var(--ds-space-300, 24px)"
  }
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const ParagraphLogin = styled.p({
  // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
  '': {
    fontSize: 'x-large',
    marginTop: "var(--ds-space-300, 24px)"
  }
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const ButtonLoginToConfluenceNewTab = styled(Button)({
  '&&': {
    fontWeight: 500,
    marginTop: "var(--ds-space-300, 24px)",
    marginBottom: "var(--ds-space-150, 12px)"
  }
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const StyledParagraph = styled.p({
  // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
  '': {
    marginTop: "var(--ds-space-150, 12px)"
  }
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const StyledLink = styled.a({
  // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
  '': {
    display: 'block'
  }
});
export const ErrorScreen = ({
  standaloneConfluenceUrl
}) => {
  const experienceTracker = useContext(ExperienceTrackerContext);
  const experience = useContext(ExperienceContext);
  const {
    formatMessage
  } = useIntl();
  useEffect(() => {
    experienceTracker.abort({
      name: experience,
      reason: ExperienceReasons.UNABLE_TO_DISPLAY_CONTENT
    });
  }, [experience, experienceTracker]);
  return /*#__PURE__*/React.createElement(Container, {
    "data-testid": "error-screen-container"
  }, /*#__PURE__*/React.createElement(ConfluenceLogo, {
    appearance: "brand",
    size: "xlarge"
  }), /*#__PURE__*/React.createElement(StyledLoginPageIconSVG, null), /*#__PURE__*/React.createElement(ParagraphLogin, null, formatMessage(messages.paragraphLogin)), /*#__PURE__*/React.createElement(ButtonLoginToConfluenceNewTab, {
    appearance: "primary",
    "aria-label": formatMessage(messages.buttonLoginToConfluenceNewTab),
    iconAfter: /*#__PURE__*/React.createElement(ShortcutIcon, {
      label: "",
      size: "medium"
    }),
    href: standaloneConfluenceUrl !== null && standaloneConfluenceUrl !== void 0 ? standaloneConfluenceUrl : '',
    target: "_blank"
  }, formatMessage(messages.buttonLoginToConfluenceNewTab)), /*#__PURE__*/React.createElement(StyledParagraph, null, formatMessage(messages.paragraphAlreadyLoggedIn)), /*#__PURE__*/React.createElement(StyledParagraph, null, formatMessage(messages.paragraphStillHavingTrouble, {
    link: /*#__PURE__*/React.createElement(StyledLink, {
      href: LOGIN_ISSUES_RELATED_TO_BROWSER_COOKIES,
      target: "_blank",
      "aria-label": formatMessage(messages.linkAriaLabel)
    }, formatMessage(messages.linkTroubleshootingText))
  })));
};